import {Program, Texture, FrameBuffer, mat4} from '../../beam/index';
import copyVS from '../shaders/copy-vs.glsl';
import copyFS from '../shaders/copy-fs.glsl';
import denoiserVS from '../shaders/denoiser-vs.glsl';
import denoiserFS from '../shaders/denoiser-fs.glsl';
import atrouVS from '../shaders/atrou-vs.glsl';
import atrouFS from '../shaders/atrou-fs.glsl';
import settings from '../settings'


export default class DenoiserRenderPass {

    constructor(renderer, options) {
        
        let FB_OPT = {
            width:  0,
            height: 0,
            linear: true,
            type:   'HALF_FLOAT'//renderer.gl.FLOAT
        }

        this.temporalThreshold        = options && options.temporalThreshold !== void 0 ? options.temporalThreshold : settings.uTemporalThreshold;
        this.bilateralBlurIterations  = options && options.bilateralBlurIterations != void 0 ? options.bilateralBlurIterations : null;
        this.useReprojection          = options && options.useReprojection         != void 0 ? options.useReprojection : true;
        this.useNeighbourgClipping    = options && options.useNeighbourgClipping  != void 0 ? options.useNeighbourgClipping : false;
        this.useTemporalUpscale       = options && options.useTemporalUpscale  != void 0 ? options.useTemporalUpscale : false;
        this.useUnjitter              = options && options.useUnjitter  != void 0 ? options.useUnjitter : false;
        this.useAtrouNoiseFilter      = options && typeof options.useAtrouNoiseFilter != void 0 ? options.useAtrouNoiseFilter  : false
        this.overrideSpatialThreshold = options && options.spatialThreshold != void 0 ? options.spatialThreshold : false


        
        this.useDepthCheck = options && options.useDepthCheck != void 0 ? options.useDepthCheck : false
        



        this.useVariance = options && options.useVariance != void 0 ? options.useVariance : false
        this.useLongHistory= options && options.useLongHistory != void 0 ? options.useLongHistory : false

        this.renderer = renderer
        this.material = new Program(this.renderer.gl,{
            vertexShader:   denoiserVS,
            fragmentShader: denoiserFS,
            depthTest:      false,
            blend:          false,
			// blendSrcRGB:    this.renderer.gl.ONE,
			// blendDstRGB:    this.renderer.gl.ONE,
			// blendSrcAlpha:  this.renderer.gl.ONE,
            // blendDstAlpha:  this.renderer.gl.ONE,
        });
        this.material.name = 'Denoiser Temporal Material'

        this.copyMaterial = new Program(this.renderer.gl,{
            vertexShader:   copyVS,
            fragmentShader: copyFS,
            depthTest:      false,
            blend:          false,
        });
        this.copyMaterial.name = 'Denoiser Copy Material'

        //ping pong accum frame buffer to accumulate frames
        this.accFrameBufferFront = new FrameBuffer(this.renderer.gl, FB_OPT);
        this.accFrameBufferBack = new FrameBuffer(this.renderer.gl, FB_OPT);
        this.writeAccFrameBuffer = this.accFrameBufferFront;
        this.readAccFrameBuffer  = this.accFrameBufferBack;

        if (this.useAtrouNoiseFilter) {
            this.atrouMaterial = new Program(this.renderer.gl,{
                vertexShader:   atrouVS,
                fragmentShader: atrouFS,
                depthTest:      false,
                blend:          false,
                // blend:          true,
                // blendSrcRGB:    this.renderer.gl.ONE,
                // blendDstRGB:    this.renderer.gl.ONE,
                // blendSrcAlpha:  this.renderer.gl.ONE,
                // blendDstAlpha:  this.renderer.gl.ONE,
            });
            this.atrouMaterial.name = 'atrouMaterial'
            this.bilateralFrameBufferFront = new FrameBuffer(this.renderer.gl, FB_OPT);
            this.bilateralFrameBufferBack = new FrameBuffer(this.renderer.gl, FB_OPT);
            this.bilateralWriteFrameBuffer = this.bilateralFrameBufferFront;
            this.bilateralReadFrameBuffer  = this.bilateralFrameBufferBack;
        }


        // if (this.useLongHistory) {
        //     this.currentHistoryIndex = 0;
        //     this.depthBufferHistory = []
        //     this.invViewProjectionHistory = []
        //     for (let i=0; i<4; i++) {
        //         this.depthBufferHistory.push( new FrameBuffer(this.renderer.gl, {
        //             width:  1,
        //             height: 1,
        //             linear: false,
        //             type:   renderer.gl.FLOAT
        //         }) )
        //         this.invViewProjectionHistory.push( mat4.create() )
        //     }
        // }

    }

    resize(w, h) 
    {
        this.w = w;
        this.h = h;
        this.accFrameBufferFront.resize(this.w,this.h);
        this.accFrameBufferBack.resize(this.w,this.h);
        this.bilateralFrameBufferFront && this.bilateralFrameBufferFront.resize(this.w,this.h);
        this.bilateralFrameBufferBack && this.bilateralFrameBufferBack.resize(this.w,this.h);

        // if (this.useLongHistory) {
        //     for (let i=0; i<4; i++) {
        //         this.depthBufferHistory[i].resize(this.w/2,this.h/2)//2 because depth is half res
        //     }
        // }
    }

    render(bufferScene, bufferPlane, bufferCamera, input, output, depth, lastDepth) 
    {

        let n = bufferPlane.id || bufferPlane.name //for debug only
        
        bufferPlane.material = this.material

        this.material.setUniform( 'tDenoiserDepth', depth)
        this.material.setUniform( 'tDenoiserLastDepth', lastDepth)

        /**
         * TEMPORAL ACCUMUMATE
         */
        this.material.setDefine( "USE_TEMPORAL_UPSCALE", settings.useTemporalUpscale && this.useTemporalUpscale ? 1 : null )
        this.material.setDefine( "USE_NEIGHBOURG_CLIPPING", this.useNeighbourgClipping && settings.canNeighbourgClipping? 1 : null )  
        this.material.setDefine( "NEIGHBOURG_CLIPPING_METHOD", settings.historyClippingMethod>>0);
        this.material.setDefine( "USE_REPROJECTION", this.useReprojection ? 1 : null)
        this.material.setDefine( "USE_VARIANCE", this.useVariance && settings.useVariance ? 1 : null)
        this.material.setDefine( 'CLEAR', settings.uClear ? 1 : null)


        // this.material.setDefine( "USE_LONG_HISTORY", this.useLongHistory && settings.useLongHistory ? 1 : null)
        // if (this.useLongHistory) {
        //     this.material.setUniform( 'uDepthHistory0', this.depthBufferHistory[0]);
        //     this.material.setUniform( 'uDepthHistory1', this.depthBufferHistory[1]);
        //     this.material.setUniform( 'uDepthHistory2', this.depthBufferHistory[2]);
        //     this.material.setUniform( 'uDepthHistory3', this.depthBufferHistory[3]);
        //     this.material.setUniform( 'uViewProjHistory0', this.invViewProjectionHistory[0]);
        //     this.material.setUniform( 'uViewProjHistory1', this.invViewProjectionHistory[1]);
        //     this.material.setUniform( 'uViewProjHistory2', this.invViewProjectionHistory[2]);
        //     this.material.setUniform( 'uViewProjHistory3', this.invViewProjectionHistory[3]);
        // }
        this.material.setDefine( "USE_DEPTH_CHECK", this.useDepthCheck ? 1 : null)
        
        this.material.setUniform( 'uDenoiserResolution', [this.w,this.h])
        this.material.setUniform( 'uTemporalThreshold', this.temporalThreshold)
        this.material.setUniform( 'uLumaThreshold', settings.uLumaThreshold)
        this.material.setUniform( 'uSpatialThreshold', this.overrideSpatialThreshold ? this.overrideSpatialThreshold : settings.uSpatialThreshold  )
        this.material.setUniform( 'uNormalThreshold', settings.uNormalThreshold)
        this.material.setUniform( 'useUnjitter', settings.useUnjitter && this.useUnjitter ? 1 : 0)
        this.material.setUniform( 'useUnjitterDepth', settings.useUnjitterDepth && this.useUnjitter ? 1 : 0)
        this.material.setUniform( 'useUnjitterLast', settings.useUnjitterLast && this.useUnjitter ? 1 : 0)

        this.material.setUniform( 'uClear', settings.uClear ? 1 : 0)

        //also use a uniform to enable disbale the effect
        //the USE_NEIGHBOURG_CLIPPING define is for performances purpose on low end devices
        // the uniform will be updated antime camera position chnages
        this.material.setUniform( 'useNeighbourgClipping', this.useNeighbourgClipping && settings.useNeighbourgClipping && settings.canNeighbourgClipping? 1 : 0)

        this.material.setUniform( 'tInput', input)
        this.renderer.clearColor(0,0,0,1)
        this.renderer.clear()
        bufferPlane.id   = n +'__accum'
        bufferPlane.name = n +'__accum'
        this.renderer.render(bufferScene, bufferCamera, this.writeAccFrameBuffer);
        let tmp                  = this.readAccFrameBuffer;
        this.readAccFrameBuffer  = this.writeAccFrameBuffer;
        this.writeAccFrameBuffer = tmp;


        /** 
        * Multipass A-TROU FILTER 
        * we add the a-trou filter after the tempral accumulation to get more temporal stability. 
        * Moreover, the A-trou filter can smooth artefacst created by the temporal accumulation
        */
       let iterations = this.bilateralBlurIterations !== null ? this.bilateralBlurIterations :  settings.bilateralBlurIterations;
       if (this.useAtrouNoiseFilter && iterations > 0) {
            bufferPlane.material = this.atrouMaterial
            this.atrouMaterial.setDefine( "USE_REPROJECTION", this.useReprojection ? 1 : null)
            this.atrouMaterial.setUniform( 'uAtrouColorThreshold', settings.uAtrouColorThreshold)
            this.atrouMaterial.setUniform( 'useAtrouNormal', settings.useAtrouNormal)
            this.atrouMaterial.setUniform( 'uAtrouNormalThreshold', settings.uAtrouNormalThreshold)
            this.atrouMaterial.setUniform( 'uAtrouPositionThreshold', settings.uAtrouPositionThreshold * settings.sceneDownscale)
            this.atrouMaterial.setUniform( 'uAtrouDepthThreshold', settings.uAtrouDepthThreshold)
            this.atrouMaterial.setUniform( 'uAtrouLuminanceThreshold', settings.uAtrouLuminanceThreshold)
            this.atrouMaterial.setUniform( 'uDenoiserResolution', [this.w,this.h])
            for (let i=0; i<iterations; i++) {
                this.atrouMaterial.setUniform('tOriginalInput', input)
                this.atrouMaterial.setUniform('tInput', i == 0 ? this.readAccFrameBuffer : this.bilateralReadFrameBuffer)
                this.atrouMaterial.setUniform('uBilateralStep', settings.bilateralBlurMethod == 0 ? i+1 :  Math.pow( 2, i ) )
                bufferPlane.id = n + '__atrou_'+i
                bufferPlane.name = n + '__atrou_'+i
                this.renderer.render(bufferScene, bufferCamera, this.bilateralWriteFrameBuffer);
                let tmp                        = this.bilateralWriteFrameBuffer;
                this.bilateralWriteFrameBuffer = this.bilateralReadFrameBuffer;
                this.bilateralReadFrameBuffer  = tmp;
            }
        }

        //COPY to output
        bufferPlane.material = this.copyMaterial;
        this.renderer.clearColor(0,0,0, 1)
        this.copyMaterial.setUniform('tInput', this.useAtrouNoiseFilter && iterations > 0 ? this.bilateralReadFrameBuffer : this.readAccFrameBuffer)
        this.renderer.clear()
        bufferPlane.id   = n + '__copy'
        bufferPlane.name = n + '__copy'
        this.renderer.render(bufferScene, bufferCamera, output);
        
        //copy Current frame to lastFrame uniform
        this.material.setUniform( 'tLastFrame', this.readAccFrameBuffer)

        // //Use 4 previous frames info instead of 1
        // if (this.useLongHistory) {
        //     mat4.copy( this.invViewProjectionHistory[this.currentHistoryIndex], bufferScene.uniforms.uInverseViewProjectionMatrix );
        //     bufferPlane.material = this.copyMaterial;
        //     this.renderer.clearColor(0,0,0, 1)
        //     this.copyMaterial.setUniform('tInput', bufferScene.uniforms.tDepth)
        //     this.renderer.clear()
        //     bufferPlane.id   = n + '__copyDepth'
        //     bufferPlane.name = n + '__copyDepth'
        //     this.renderer.render(bufferScene, bufferCamera, this.depthBufferHistory[this.currentHistoryIndex]);
        //     this.currentHistoryIndex++
        //     this.currentHistoryIndex = this.currentHistoryIndex % 4;
        // }


    }

}